import { Color } from 'presentation/theme/colorScheme';

const dividerTheme = {
  baseStyle: {
    height: '2px',
    bgColor: Color.Shade100,
    borderBottomWidth: '0px',
    opacity: 1,
  },
};

export default dividerTheme;
